export default "__VITE_ASSET__1270e783__"